import { Dropdown, Menu } from "antd";
import React, { useState } from "react";
import arrow from "../../../assets/svgs/header-icon/arrow-down.svg";
import arrowGrey from "../../../assets/svgs/header-icon/arrow-down-grey.svg";

import { TransactionTypeItems } from "../FilterItems/TransactionTypeItems";
import SpMenu from "../../SpMenu/SpMenu";

const TransactionFilter = ({onChange}) => {
  const [transaction, setTransaction] = useState("Search status");
  const [selected, setSelected] = useState(false);

  function handleFilterSelect({item, index}) {
    setTransaction(item?.bill?? 'All');

    setSelected(true);

    if (typeof onChange === "function") {
      onChange(item?.bill?? '');
    }
  }

  const menu = (
    <SpMenu items={TransactionTypeItems} renderItem={(item) => <p>{item.bill}</p>} onSelect={handleFilterSelect} />
  );


  return (
    <div className="filter-modal-inner">
      <p>Transaction Type</p>
      <Dropdown overlay={menu} trigger={["click"]}>
        <button
          className={
            selected ? "selected filter-modal-btn" : "filter-modal-btn"
          }
        >
          {" "}
          {transaction}
          <span className="filter-icon">
            {selected ? (
              <img src={arrow} alt="/" />
            ) : (
              <img src={arrowGrey} alt="/" />
            )}
          </span>{" "}
        </button>
      </Dropdown>
    </div>
  );
};

export default TransactionFilter;
